module.exports = __webpack_public_path__ + "img/制御工学5_7_3.d464d436.png";